import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { yellow, white, navy, grey25, grey75 } from '@zocdoc/branding/colors';
import { FontFamily } from '@zocdoc/components/src/typography';
import { Modal, ModalHeader, ModalBodyCopy, ModalButtonContainer } from '@zocdoc/components/src/modal';
import { breakpoint, Breakpoints } from '@zocdoc/components/src/grid';
import { Info } from '@zocdoc/components/src/icons';
import { Button } from '@zocdoc/components/src/button';
import { LOCALIZED_STRINGS } from './constants';

const Container = styled.div`
    display: flex;
    margin-bottom: 8px;
    position: relative;
    width: max-content;

    ${breakpoint.small} {
        div + div:hover + div {
            display: block;
        }
    }
`;

const SpoBanner = styled.div`
    background: ${yellow};
    border-radius: 2px;
    font: 9px ${FontFamily.SharpSansBold};
    letter-spacing: 1px;
    padding: 4px 6px;
    text-transform: uppercase;
`;

const TelBanner = styled(SpoBanner)`
    background: ${navy};
    color: ${white};
`;

const Icon = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    margin-left: 6px;
`;

const StyledInfo = styled(Info)`
    font-size: 12px;
`;

const FloatingMessage = styled.div`
    background-color: ${white};
    border: ${grey25} 1px solid;
    color: ${navy};
    display: none;
    font: 14px/20px ${FontFamily.KievitSlabBook};
    padding: 15px;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateY(-50%) translateX(calc(6px + 100%));
    width: 250px;
    z-index: 300;
`;

const FloatingMessageTitle = styled.div`
    font: 15px/20px ${FontFamily.SharpSansSemibold};
    margin-bottom: 5px;
`;

const ModalContainer = styled.div`
    ${breakpoint.small} {
        display: none;
    }
`;

const StyledButton = styled(Button)`
    width: 100%;
`;

const message = {
    title: 'What is this?',
    contents: 'Sponsored Results feature healthcare providers who paid Zocdoc to appear above your search listings. Have questions? Contact us at (855) 962-6556.',
};

const isMobile = () => typeof window !== 'undefined' && window.innerWidth < Breakpoints.small;

export class BaseSpoBanner extends React.Component {
    state = { isShowing: false }

    toggleModal = ev => {
        if (isMobile()) {
            if (ev) {
                ev.stopPropagation();
                ev.preventDefault();
            }

            this.setState(prevState => ({ isShowing: !prevState.isShowing }));
        }
    }

    renderModal = () => {
        return (
            <ModalContainer>
                <Modal onClickCancel={this.toggleModal}>
                    <ModalHeader>
                        {message.title}
                    </ModalHeader>

                    <ModalBodyCopy>
                        {message.contents}
                    </ModalBodyCopy>

                    <ModalButtonContainer>
                        <StyledButton
                            onClick={this.toggleModal}
                            style={Button.STYLE.TRANSPARENT}
                        >
                            Close
                        </StyledButton>
                    </ModalButtonContainer>
                </Modal>
            </ModalContainer>
        );
    }

    render() {
        return (
            <Container>
                {this.renderBanner()}

                <Icon
                    onClick={this.toggleModal}
                    title=""
                >
                    <StyledInfo
                        alt={message.title}
                        color={grey75}
                    />
                </Icon>

                <FloatingMessage>
                    <FloatingMessageTitle>{message.title}</FloatingMessageTitle>
                    <div>{message.contents}</div>
                </FloatingMessage>

                {this.state.isShowing && this.renderModal()}
            </Container>
        );
    }

    renderBanner() {
        if (this.props.isTelehealth) {
            return (
                <TelBanner data-test="sponsored-tel-result-banner">
                    <FormattedMessage
                        defaultMessage={LOCALIZED_STRINGS.SponsoredTelemedicineText.defaultMessage}
                        id="SearchResults.SponsoredTelemedicineBanner.SponsoredText"
                    />
                </TelBanner>
            );
        }

        return (
            <SpoBanner data-test="sponsored-result-banner">
                <FormattedMessage
                    defaultMessage={LOCALIZED_STRINGS.SponsoredText.defaultMessage}
                    id="SearchResults.SponsoredBanner.SponsoredText"
                />
            </SpoBanner>
        );
    }
}

export default injectIntl(BaseSpoBanner);
